import { render, staticRenderFns } from "./mapCard2.vue?vue&type=template&id=8979dcc0&scoped=true"
import script from "./mapCard2.vue?vue&type=script&lang=js"
export * from "./mapCard2.vue?vue&type=script&lang=js"
import style0 from "./mapCard2.vue?vue&type=style&index=0&id=8979dcc0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8979dcc0",
  null
  
)

export default component.exports